import { Router } from 'vue-router'
import { useAppStore } from '@/modules/app/app.store'

export default {
  handler(router: Router, error: any) {
    useAppStore().error = 429
  },
}
